module.exports = __webpack_public_path__ + "media/ee-animation-720.cba94c6b.mp4";